import {gql} from 'apollo-angular';

export const GET_NOGA_INDUSTRIES = gql`
  query {
    nogaIndustries {
      code
      title {
        en
        de
        fr
        it
      }
    }
  }
`;
